export function roundNumber(num: number, decimals: number) {
  // https://stackoverflow.com/a/11832950
  // Math.round only rounds to the nearest integer.  So we have to do some extra magic to make it work with decimals.
  const decimalFactor = 10 ** decimals;
  return Math.round((num + Number.EPSILON) * decimalFactor) / decimalFactor;
}
